import React, { Component } from 'react'
import Button from "reactstrap/es/Button"
import BulkGenLabelModal from './BulkGenLabelModal'

class BulkGenLabel extends Component {
    state = {
        isOpen: false,
    }

    _handleToggleModal = () => {
        const { selectedItems, resetBulkAll, reloadItems, closeMenu } = { ...this.props }
        const { isOpen } = this.state

        if (!isOpen) {
            const r = window.confirm(`Are you sure want to do Gen label for ${selectedItems.length} ${selectedItems.length > 1 ? 'orders' : 'order'} selected?`)

            if (r !== true) {
                resetBulkAll()
                closeMenu()
                return
            }
        }

        this.setState({
            isOpen: !isOpen
        })

        if (isOpen) {
            resetBulkAll()
            closeMenu()
            reloadItems()
        }
    }

    render() {
        const { isOpen } = this.state
        const { items = [], selectedItems = [] } = { ...this.props }
        const listItems = items.filter(item => selectedItems.includes(item._id))
        const listItemsDisable = listItems.filter(itemH => (['labelled', 'packaged', 'cancelled', 'cancel-ship'].includes(itemH.production_status)))
        const disabledBtn = listItemsDisable.length > 0

        return (
            <div>
                <Button color="link" onClick={this._handleToggleModal} className="mr-1" disabled={disabledBtn}>Generate label</Button>
                {isOpen && (
                    <BulkGenLabelModal
                        {...this.props}
                        isOpen={isOpen}
                        handleToggleModal={this._handleToggleModal}
                    />
                )}
            </div>
        );
    }

}

export default BulkGenLabel